import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Fetch/QR_CODE_ERROR',
    PENDING: 'Fetch/QR_CODE_PENDING',
    SUCCESS: 'Fetch/QR_CODE_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
